import { render } from "./SettingsCard.vue?vue&type=template&id=554e243e"
import script from "./SettingsCard.vue?vue&type=script&lang=js"
export * from "./SettingsCard.vue?vue&type=script&lang=js"

import "./SettingsCard.vue?vue&type=style&index=0&id=554e243e&lang=scss"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__